import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)
Vue.config.productionTip = false
function px2rem (px) {
  return (parseFloat(px) / 16).toFixed(2) +'rem'
}
Vue.prototype.$px2rem = px2rem
import './utils/rem'
axios.get('/config.json?time=' + new Date().getTime()).then(res => {
  store.commit('page/SET_PAGECONFIG', res.data)

  new Vue({
    router,
    store,
    render: function (h) { return h(App) }
  }).$mount('#app')
})
